import type { Context } from 'react';
import { useContext } from 'react';

export const useContextEnsuringProvider = <T>(
  context: Context<T | null>,
  displayName?: string
): NonNullable<T> => {
  const returnedContext = useContext(context);
  const contextName = displayName || context.displayName;

  if (returnedContext === null || returnedContext === undefined) {
    throw Error(
      `${contextName || context.Consumer.name} Context must be used in a ${contextName || context.Provider.name} Provider`
    );
  }

  return returnedContext;
};
